import jwtDecode from "jwt-decode";
import type { UseFormSetValue } from "react-hook-form";

import { trackCustomEvent } from "../../utils/analytics";
import type { RegisterInputProps } from "../../utils/coReg";

export type CredentialResponse = {
  /** This field is the returned ID token */
  credential?: string;
  /** This field sets how the credential is selected */
  select_by?:
    | "auto"
    | "user"
    | "user_1tap"
    | "user_2tap"
    | "btn"
    | "btn_confirm"
    | "brn_add_session"
    | "btn_confirm_add_session";
  clientId?: string;
};

type CredentialResponseDecoded = {
  email: string;
  name: string;
  given_name: string;
  family_name: string;
};

export function onSuccess(
  response: CredentialResponse,
  gaCategory: "Path" | "SERP",
  gaLabel: string,
  setValue: UseFormSetValue<RegisterInputProps>,
  onSubmit: () => void
) {
  if (typeof response?.credential !== "string") {
    trackCustomEvent({
      category: gaCategory,
      action: "Couldn't read email from Google OneTap",
      label: gaLabel,
    });
    return;
  }
  const credential: CredentialResponseDecoded = jwtDecode(response.credential);
  if (!credential) {
    trackCustomEvent({
      category: gaCategory,
      action: "Couldn't decode user details from Google OneTap credentials",
      label: gaLabel,
    });
    return;
  }
  let { email, name, given_name, family_name } = credential;
  if (!given_name && !family_name) {
    const nameParts = name.split(" ");
    given_name = nameParts[0] || "";
    family_name = nameParts.length > 1 ? nameParts.slice(-1)[0] : "";
  }
  if (email) {
    setValue("email", email);
    trackCustomEvent({
      category: gaCategory,
      action: "Email stored from Google OneTap",
      label: gaLabel,
    });
  }
  if (given_name) {
    setValue("firstname", given_name);
    trackCustomEvent({
      category: gaCategory,
      action: "firstname stored from Google OneTap",
      label: gaLabel,
    });
  }
  if (family_name) {
    setValue("lastname", family_name);
    trackCustomEvent({
      category: gaCategory,
      action: "lastname stored from Google OneTap",
      label: gaLabel,
    });
  }
  onSubmit();
}

export function onError(gaCategory: "Path" | "SERP", gaLabel: string) {
  trackCustomEvent({
    category: gaCategory,
    action: "Error reading credentials from Google OneTap",
    label: gaLabel,
  });
}
